export default __webpack_public_path__ + "static/media/bg.6ada60e4.svg";